import { useContext, useState } from "react";
import { FileFinepModel } from "../../../../Models/FileFinepModel";
import UploadInputByDocType from "../../../../Components/RegistrationDocumentsFinep/UploadInputByDocType";
import { RegistrationDocumentsFinepContext } from "../../../../Contexts/RegistrationDocumentsFinepContext";
import { BellOutlined, PlusOutlined } from "@ant-design/icons";
import ModalNotificationFinep from "../../../../Components/ModalNotificationFinep";
import { GetTenantIdSession } from "../../../../Utils/StorageSessions";
import { GetAllExternalEmailsByTenantAPI } from "../../../../API/FinepNotification";
import useLoading from "../../../../Hooks/useLoading";
import { IResponseProps } from "../../../../Interfaces/IResponseProps";
import { Checkbox, Button, Row, Col, Typography } from "antd";
import "./styles.css";
const { Text, Title } = Typography;
interface FinalcialStatementsTabProps {
    files: FileFinepModel[];
}
const FinancialStatementsTab = ({ files }: FinalcialStatementsTabProps) => {
    const [hasDREDocuments, setHasDREDocuments] = useState(false);
    const { changeTab } = useContext(RegistrationDocumentsFinepContext);
    const [openModal, setOpenModal] = useState(false);
    const { loading, toggleLoading } = useLoading();
    const [emails, setEmails] = useState<string[]>([]);
    const getEmails = async () => {
        try {
            toggleLoading(true);
            const tenantId = GetTenantIdSession();
            const resp: IResponseProps = await GetAllExternalEmailsByTenantAPI(tenantId);
            if (resp.statusCode === 200) {
                setEmails(resp.data.resp);
                HandleModal();
            }
        } finally {
            toggleLoading(false);
        }
    };
    const HandleModal = () => setOpenModal(!openModal);
    const SendNotification = () => {
        if (hasDREDocuments) {
            setHasDREDocuments(true);
        }
        getEmails();
    };
    return (
        <>
            <div className="header-container">
                <BellOutlined className="notification-icon" />  {/* onClick={SendNotification} */}
            </div>
            <Row gutter={[16, 16]} align="middle">
                <Col span={17} />
                <Col span={3}>
                    <Text className="label-text">Validado?</Text>
                </Col>
                <Col span={3}>
                    <Text className="label-text">Notificar</Text>
                </Col>
                <Col span={24}>
                    <Title level={5} className="section-title">
                        Balancete (Mais Recente):
                    </Title>
                </Col>
                <UploadInputByDocType files={files} docType={2} />
                <Col span={24}>
                    <Title level={5} className="section-title">
                        Balanço Patrimonial:
                    </Title>
                </Col>
                <UploadInputByDocType files={files} docType={1} />
                <Col span={24}>
                    <Title level={5} className="section-title">
                        Demonstração do Resultado do Exercício (DRE):
                    </Title>
                </Col>
                <Col span={24}>
                    <Checkbox
                        checked={hasDREDocuments || files.some((x) => x.docType === 0)}
                        onChange={(e) => setHasDREDocuments(e.target.checked)}
                    >
                        Informações de Balanço Patrimonial e Demonstração do Resultado do Exercício se encontram no mesmo documento.
                    </Checkbox>
                </Col>
                {!hasDREDocuments || files.some((x) => x.docType === 0) ? (
                    <UploadInputByDocType files={files} docType={0} />
                ) : null}
                <Col span={24}>
                    <Title level={5} className="section-title">
                        Organograma da Composição do Grupo:
                    </Title>
                </Col>
                <UploadInputByDocType files={files} docType={3} />
            </Row>
            <div className="button-container">
                <Button type="primary" onClick={() => changeTab(1)}>
                    <PlusOutlined /> Próxima Etapa
                </Button>
            </div>
            <ModalNotificationFinep
                open={openModal}
                handleClose={HandleModal}
                emailsToSelect={emails}
                toggleLoading={toggleLoading}
                cardName=""
                registerId=""
                tabName=""
            />
        </>
    );
};
export default FinancialStatementsTab;